import App from './components/App';

const app = new App('MovieSearch');

app.init();
